<template>
  <div class="alignment-widget">
    <Portal to="alignment-widget-controls">
      <div class="portal-content">
        <div class="controls">
          <span>{{ $t('textAlignmentsWidget.thresholdLabel') }}</span>
          <VueSlider :direction="sliderDirection" :lazy="true" :tooltip-placement="'bottom'" v-model="sliderValue" />
        </div>
        <PortalTarget
          :name="'aw-additional-controls'"
        />
      </div>
    </Portal>
    <Alignment
      :alignments="selectedAlignments"
      @addId="onAddParts"
      @close="clearAlignment"
    />
  </div>
</template>

<script>
  import { Portal, PortalTarget } from 'portal-vue';
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/antd.css';

  import { CLEAR_ALIGNMENT, SET_TEXT_REUSE_MATCH_THRESHOLD } from '../constants';
  import i18n from '../i18n';
  import Alignment from '../components/Alignment.vue';
  import utils from '../utils';
  import mixins from '../mixins';

  export default {
    scaifeConfig: {
      displayName: () => i18n.t('textAlignmentsWidget.title'),
      portalTarget: 'alignment-widget-controls',
    },
    mixins: [mixins.RouteSelectionsMixin, mixins.LocaleIsRTLMixin],
    components: {
      Alignment,
      Portal,
      PortalTarget,
      VueSlider,
    },
    computed: {
      selectedAlignments() {
        return this.$store.state.selectedAlignments || [];
      },
      sliderDirection() {
        return this.locale_is_rtl ? 'rtl' : 'ltr';
      },
      sliderValue: {
        get() {
          return this.$store.state.textReuseMatchThreshold;
        },
        set(value) {
          this.$store.dispatch(SET_TEXT_REUSE_MATCH_THRESHOLD, { value });
        },
      },
    },
    methods: {
      clearAlignment() {
        this.$store.dispatch(CLEAR_ALIGNMENT);
      },
      onAddParts(idParts) {
        const { workUrn, sectionIdx, lineIdx } = idParts;
        const tokenIdx = idParts.tokenIdx || null;

        const id = utils.makeId(workUrn, sectionIdx, lineIdx, tokenIdx);
        if (!this.maxSelected && this.selectedIds.indexOf(id) === -1) {
          this.$router.push({
            name: 'reader',
            query: { urn: [...this.selectedIds, id] },
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../_variables.scss";
  #app[data-locale="ar"] .alignment-widget {
    direction: rtl;
    font-family: $ar-font-family;
    font-size: $ar-default-font-size;
  }
  #app[data-locale="ar"] .controls {
    font-family: $ar-font-family;
    font-size: $ar-default-font-size;
    direction: rtl;
    margin-right: 1em;
    input {
      margin-right: 2em;
    }
  }
  .controls {
    background: white;
    margin-left: 1em;
    input {
      margin-left: 2em;
    }
  }

</style>
